// extracted by mini-css-extract-plugin
export default {"PageNotFound_container":"PageNotFound_PageNotFound_container__80ObL","PageNotFound_parent":"PageNotFound_PageNotFound_parent__GrsyC","backtoHome":"PageNotFound_backtoHome__cO0IQ"};